import { styled } from 'styled-components';

import { cssBreakpoints } from 'theme/theme';
import { retinaBackgroundImage } from 'utils/style';

import { headerImageUrl } from './headerImageUrl';

export const Banner = styled.div<{
  $handle: string;
  $mimetype: string | undefined;
}>`
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;

  ${(props) =>
    retinaBackgroundImage(
      headerImageUrl({
        handle: props.$handle,
        mimetype: props.$mimetype,
        ratio: 1,
        width: 320,
        height: 35,
      }),
      {
        filename2x: headerImageUrl({
          handle: props.$handle,
          mimetype: props.$mimetype,
          ratio: 2,
          width: 320,
          height: 35,
        }),
        filename3x: headerImageUrl({
          handle: props.$handle,
          mimetype: props.$mimetype,
          ratio: 3,
          width: 320,
          height: 35,
        }),
      },
    )};
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    /* block-no-empty */
    ${(props) =>
      retinaBackgroundImage(
        headerImageUrl({
          handle: props.$handle,
          mimetype: props.$mimetype,
          ratio: 1,
          width: 1440,
          height: 200,
        }),
        {
          filename2x: headerImageUrl({
            handle: props.$handle,
            mimetype: props.$mimetype,
            ratio: 2,
            width: 1440,
            height: 200,
          }),
          filename3x: headerImageUrl({
            handle: props.$handle,
            mimetype: props.$mimetype,
            ratio: 3,
            width: 1440,
            height: 200,
          }),
        },
      )};
  }
`;
